import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Link from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect, useState } from "react";
import { ResolveThunks, connect } from "react-redux";
import { css } from "styled-components";
import customLoadInventory from "@NA/Handlers/GetInventory";
import CrossIcon from "@NA/Icons/CrossIcon";
import ADILocationFinder from "../ADILocationFinder";
import { getMaxProductHeight } from "@NA/Utils/Utility";
import ADILBShippedByVendor from "@NA/Components/ADILBShippedByVendor";
import { GridItem } from "@insite/mobius/index";
import { StyledButton } from "@insite/mobius/Clickable";

interface OwnProps {
    product: ProductModel;
    view?: string;
    showAuthorizationRequired: string;
    extendedStyles?: ADIProductAvailabilityStyles;
}

const mapDispatchToProps = {
    customLoadInventory,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export interface ADIProductAvailabilityStyles {
    availibilityGrid?: InjectableCss;
    stockMsg?: TypographyProps;
    divider?: TypographyProps;
    availibility?: TypographyProps;
    lowStockIndicator?: TypographyProps;
    stockIndicator?: TypographyProps;
    availabilityByWarehouseModal?: ModalPresentationProps;
}

export const adiProductAvailabilityStyles: ADIProductAvailabilityStyles = {
    availibilityGrid: {
        css: css`
            order: initial;
            margin-bottom: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css``,
                        css``,
                        css`
                            order: 4;
                            margin-bottom: 20px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
            > span {
                margin-right: 10px;
                font-size: 14px;
                > ${StyledButton} {
                    align-items: flex-start;
                }
            }
        `,
    },
    stockMsg: {
        css: css`
            font-size: ${getProp("theme.typography.h6.size")};
            font-weight: 700;
            color: ${ADIColors.darkBlack3};
        `,
    },
    availibility: {
        css: css`
            font-size: ${getProp("theme.typography.h6.size")};
            &:hover {
                span {
                    text-decoration: underline !important;
                    color: ${ADIColors.blue5}!important;
                }
            }
            a:hover {
                text-decoration: underline;
                color: ${ADIColors.blue5};
            }
            span {
                font-size: 14px;
                font-weight: bold;
                display: inline;
                margin-top: 0px;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                                font-size: ${getProp("theme.typography.headerSecondary.size")};
                                display: block;
                                margin-top: 6px;
                            `,
                        css``,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                )}
            }
        `,
    },
    divider: {
        css: css`
            color: ${ADIColors.gray3};
            display: inline;
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: none;
                        `,
                        css``,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    lowStockIndicator: {
        css: css`
            width: 10px;
            height: 10px;
            display: inline-block;
            background: ${ADIColors.warningDot};
            border-radius: 50%;
            margin-right: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: none;
                        `,
                        css``,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    stockIndicator: {
        css: css`
            width: 10px;
            height: 10px;
            display: inline-block;
            background: ${ADIColors.lightGreen1};
            border-radius: 50%;
            margin-right: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: none;
                        `,
                        css``,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    availabilityByWarehouseModal: {
        sizeVariant: "medium",
        closeButtonIconProps: {
            src: CrossIcon,
            size: 20,
        },
        cssOverrides: {
            modalBody: css`
                max-width: 730px !important;
                border-radius: 4px;
                padding: 28px !important;
                height: auto !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            border-radius: 0 !important;
                            max-width: calc(100% - 20px)!important;
                            max-height: 80%;
                        `,
                        css`
                            border-radius: 0 !important;
                            max-width: calc(100% - 20px)!important;
                            max-height: 80%;
                        `,
                        null,
                        null,
                        null,
                    ])}
            `,
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                border-bottom: 0;
                padding: 0 !important;
                margin-bottom: 20px;
                > h4 {
                    font-size: 32px;
                    font-weight: bold;
                    line-height: normal;
                    color: ${ADIColors.darkBlue1};
                }
                button {
                    border-radius: 0;
                    svg {
                        height: 20px;
                    }
                }
            `,
            headlineTypography: css`
                font-size: 20px;
                margin-bottom: 0;
            `,
        },
    },
};

const ADIProductAvailability: FC<Props> = ({
    product,
    view,
    showAuthorizationRequired,
    customLoadInventory,
    extendedStyles,
}) => {
    const [styles] = React.useState(() => mergeToNew(adiProductAvailabilityStyles, extendedStyles));
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [inventoryResult, setInventoryResult] = React.useState<any>(null);

    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };

    const viewAvailabilityByWarehouseClickHandler = () => {
        setModalIsOpen(true);

        customLoadInventory({
            productId: product.erpNumber || product.productNumber,
            onSuccess(result: any) {
                setInventoryResult(result);
            },
        }as any);
    };

    // if (showAuthorizationRequired === "true") {
    //     return null;
    // }

    const [minStockHeight, setMinStockHeight] = useState(15);
    useEffect(() => {
        const maxStockAvailableHeight = getMaxProductHeight('[data-test-selector="stockAvailable"]');
        setMinStockHeight(maxStockAvailableHeight);
    }, []);

    if (showAuthorizationRequired !== "true") {
        return (
            product.properties["logicBroker"] && product.properties["logicBroker"]?.toLowerCase() === "yes" ?
                (
                    <ADILBShippedByVendor vendorName={product.brand?.name ?? ""} view={"Grid"} />
                ) : (
                    <StyledWrapper >
                        {!product.properties["inventoryMessage"] ||
                            product.properties["inventoryMessage"] !== "Special Order" ? (
                            <Typography {...styles.availibilityGrid}>
                                {view === "List" && (
                                    <>
                                        <Typography {...styles.stockMsg}>
                                            {product.properties["inventoryMessage"] !== "DISCONTINUED" ? (
                                                <Typography
                                                    {...(product.properties["inventoryMessage"] === "Low Stock"
                                                        ? styles.lowStockIndicator
                                                        : styles.stockIndicator)}
                                                ></Typography>
                                            ) : null}

                                            {product.properties["inventoryMessage"]}
                                        </Typography>
                                        <Typography {...styles.divider}>|</Typography>
                                    </>
                                )}
                                <Typography {...styles.availibility}>
                                    <Link
                                        onClick={viewAvailabilityByWarehouseClickHandler}
                                        data-test-selector="stockAvailablee"
                                    >
                                        {translate("Stock Availability")}
                                    </Link>
                                </Typography>
                                <Modal
                                    {...styles.availabilityByWarehouseModal}
                                    headline={translate("Stock Availability")}
                                    isOpen={modalIsOpen}
                                    handleClose={modalCloseHandler}
                                >
                                    <ADILocationFinder productId={product.productNumber} warehouseDetails={inventoryResult} />
                                </Modal>
                            </Typography>
                        ) : (
                            <Typography {...styles.availibilityGrid}>
                                <Typography {...styles.stockMsg}>{translate("Special Order")}</Typography>
                            </Typography>
                        )}
                    </StyledWrapper>
                )
        );
    } else {
        return null;
    }
};

export default connect(null, mapDispatchToProps)(ADIProductAvailability);
